import { z } from 'zod';

export {
  MAX_DICTATION_BYTES,
  MAX_DICTATION_SECONDS,
  DICTATION_MEDIA_TYPES,
  DICTATION_PLAN_IDS,
  includesDictation,
} from './dictation-data';

export const TranscriptionResponseSchema = z.object({
  text: z.string().trim().min(1),
  /**
   * Set when today's credits ran out before the recording's end: the text is of its first this
   * many seconds, all the credits paid for.
   */
  cutAt: z.number().int().positive().optional(),
});

/** Only public recording settings; whether audio transcription is available. */
export const DictationConfigSchema = z.object({ enabled: z.boolean() });
export type DictationConfig = z.infer<typeof DictationConfigSchema>;
